import React, { useState } from 'react';
import { Form } from "reactstrap";


const SearchForm = (props) => {

    const [formState, setFormState] = useState({
        keyword: ''
    });

    const submitForm = async (event) => {
        event.preventDefault();
        if(!formState.keyword) {
            return;
        }
        props.handler(formState.keyword);
    }

    const handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        let formFields = { ...formState };
        formFields[name] = value;
        setFormState(formFields);
    }

    return (
        <Form onSubmit={submitForm} className="kt-form kt-form--label-right p-3">
            <div className="input-group">
                <input type="text" className="form-control" placeholder="Search by keyword" name="keyword" value={formState.keyword || ''} onChange={handleInputChange} />
                <div className="input-group-append">
                    <button className="btn btn-primary" type="submit">GO</button>
                </div>
            </div>
        </Form>);
}
export default SearchForm;